import React, { useEffect, useMemo, useState } from "react";
import "./IndependenceDay.scss";
import { isIndependenceWindow, prefersReducedMotion } from "../lib/independenceDay";

// ─── Tricolour ribbon burst ───────────────────────────────────────────────────
// Fires once per session, ~5s, then unmounts itself. Purely decorative and
// pointer-events:none, so it can never sit between a user and a CTA.

const RIBBON_COLORS = ["#FF9933", "#FFFFFF", "#138808", "#FF9933", "#138808", "#000080"];

function RibbonBurst() {
  const [alive, setAlive] = useState(true);

  const ribbons = useMemo(
    () =>
      Array.from({ length: 30 }, (_, i) => ({
        left:  `${(i * 3.4 + Math.random() * 3) % 100}%`,
        dx:    `${(Math.random() - 0.5) * 160}px`,
        rot:   `${420 + Math.random() * 620}deg`,
        dur:   `${3.4 + Math.random() * 2.4}s`,
        delay: `${Math.random() * 1.6}s`,
        w:     `${5 + Math.random() * 4}px`,
        h:     `${11 + Math.random() * 9}px`,
        bg:    RIBBON_COLORS[i % RIBBON_COLORS.length],
      })),
    []
  );

  useEffect(() => {
    const t = setTimeout(() => setAlive(false), 7000);
    return () => clearTimeout(t);
  }, []);

  if (!alive) return null;

  return (
    <div className="iday-burst" aria-hidden="true">
      {ribbons.map((r, i) => (
        <span
          key={i}
          className="iday-burst__ribbon"
          style={{
            left: r.left,
            width: r.w,
            height: r.h,
            background: r.bg,
            animationDuration: r.dur,
            animationDelay: r.delay,
            "--dx": r.dx,
            "--rot": r.rot,
          }}
        />
      ))}
    </div>
  );
}

// ─── Global I-Day layer ───────────────────────────────────────────────────────

export default function IndependenceDay() {
  const on = isIndependenceWindow();
  const [burst, setBurst] = useState(false);

  useEffect(() => {
    if (!on) return;
    document.body.classList.add("iday-on");

    if (!prefersReducedMotion() && !sessionStorage.getItem("cogradIdayBurst")) {
      sessionStorage.setItem("cogradIdayBurst", "1");
      setBurst(true);
    }
    return () => document.body.classList.remove("iday-on");
  }, [on]);

  if (!on) return null;

  return (
    <>
      {/* Tricolour hairline pinned to the top edge — zero layout shift */}
      <div className="iday-hairline" aria-hidden="true">
        <span className="iday-hairline__sheen" />
      </div>
      {burst && <RibbonBurst />}
    </>
  );
}
